/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/label-has-associated-control */
import _ from 'lodash'
import React, {
  useMemo,
  useEffect,
  useState,
  useRef,
} from 'react'
// import {
//   Field,
// } from 'formik'
import { usePrevious } from '../../hook'
import combineClassNames from '../../helpers/combineClassNames'
import {
  customStylesQuantityPicker,
} from '../dropdown/custom-styles'
import Dropdown from '../dropdown'
import useStyles from './input-quantity-style'

const InputQuantityView = ({
  valueEditMode = 'default', // 'default' or 'picker' or 'input'
  max = Infinity,
  min = 0,
  step = 1,
  incrementStep,
  decrementStep,
  value = 0,
  inline = false,
  disabled,
  readOnly = false,
  onChange,
  onFocus,
  onBlur,
  loading = false,
  deferedValueUpdate = false,
  // formik,
}) => {
  const incStep = _.isNumber(incrementStep) ? incrementStep : step
  const decStep = _.isNumber(decrementStep) ? decrementStep : step
  const updateFailureTimerRef = useRef(null)
  const [validValue, setValidValue] = useState(value)
  const [valueUpdatedByControls, setValueUpdatedByControls] = useState(value)
  const [updateFailed, setUpdateFailed] = useState(false)
  const inputRerenderKey = useMemo(() => (
    `quantity_input_${valueUpdatedByControls}`
  ), [valueUpdatedByControls])
  const prevValue = usePrevious(validValue)
  const qtyList = _.map(
    _.range(min, _.min([max + 1, 999]), step),
    (i) => ({
      label: i.toString(),
      value: i,
    }),
  )
  const valueZeroView = useMemo(() => (
    valueUpdatedByControls === 0 && min === 0 && inline
  ), [valueUpdatedByControls, min, inline])
  const goingToZero = useMemo(() => (
    valueUpdatedByControls === 1 && min === 0
  ), [valueUpdatedByControls, min])
  const styles = useStyles({ valueZeroView })
  const onIncrease = () => {
    const newValue = _.clamp(valueUpdatedByControls + incStep, min, max)
    setValueUpdatedByControls(newValue)
  }
  const onDecrease = () => {
    const newValue = _.clamp(valueUpdatedByControls - decStep, min, max)
    setValueUpdatedByControls(newValue)
  }
  const onPickerChange = (option) => {
    setValueUpdatedByControls(option.value)
  }
  const onInputBlur = ({ nativeEvent }) => {
    if (_.isFunction(onBlur)) onBlur({ nativeEvent })
    const text = _.get(nativeEvent, 'target.value', value)
    let valueInNumber = _.toNumber(text)
    if (_.isEmpty(text)) {
      valueInNumber = value
    }
    if (
      _.isFunction(onChange)
      && value !== valueInNumber
    ) setValueUpdatedByControls(valueInNumber)
  }
  const handleInputFocus = (event) => {
    event.preventDefault()
    if (!_.inRange(value, min, max + 1)) {
      _.set(event, 'target.value', '')
      if (_.isFunction(onChange)) onChange(prevValue)
      event.target.focus()
    }
    event.target.select()
    if (_.isFunction(onFocus)) onFocus(event)
  }

  const renderValue = () => {
    switch (disabled || readOnly ? 'default' : valueEditMode) {
      case 'picker':
        return (
          <Dropdown
            className={styles.quantityDropdown}
            widthDropdown="100%"
            values={valueUpdatedByControls}
            customStyles={customStylesQuantityPicker}
            options={qtyList}
            onChange={onPickerChange}
            isSearchable={false}
          />
        )
      case 'input':
        return (
          <input
            key={inputRerenderKey}
            type="number"
            inputMode="numeric"
            name="quantity_input"
            max={max}
            min={min}
            step={step}
            placeholder={validValue}
            defaultValue={valueUpdatedByControls}
            onBlur={onInputBlur}
            onFocus={handleInputFocus}
            className={styles.quantityInput}
          />
        )
      default:
        return (
          <div
            className={combineClassNames([
              styles.value,
              inline && styles.valueInline,
              valueUpdatedByControls !== value && styles.valueInactive,
              updateFailed && styles.valueFailed,
            ])}
          >
            {valueUpdatedByControls}
          </div>
        )
    }
  }

  const updateValue = useMemo(() => (
    _.debounce(
      (v) => {
        if (v !== value) {
          onChange(v)
        }
      },
      (deferedValueUpdate ? 800 : 10),
    )
  ), [value])
  useEffect(() => {
    if (
      _.isFunction(onChange)
    ) {
      updateValue(valueUpdatedByControls)
    }
  }, [valueUpdatedByControls])

  useEffect(() => {
    if (!loading) {
      // when loading turns false, but the value is not updated
      //  then it means that the update failed
      updateFailureTimerRef.current = setTimeout((a, b) => {
        if (a !== b) {
          setUpdateFailed(true)
        }
      }, 100, valueUpdatedByControls, value)
    }
  }, [loading])

  useEffect(() => {
    if (valueUpdatedByControls === value) {
      clearTimeout(updateFailureTimerRef.current)
    }
  }, [valueUpdatedByControls, value])

  useEffect(() => {
    if (updateFailed) {
      setValueUpdatedByControls(value)
      _.delay(() => setUpdateFailed(false), 500)
    }
  }, [updateFailed])

  useEffect(() => {
    if (_.inRange(valueUpdatedByControls, min, max + 1)) {
      setValidValue(valueUpdatedByControls)
    }
  }, [valueUpdatedByControls, min, max])

  return (
    <div className={combineClassNames([styles.container, inline && styles.containerInline])}>
      { !valueZeroView && (
        <button
          type="button"
          className={
            combineClassNames([
              styles.button,
              valueZeroView && styles.buttonValueZeroView,
              styles.buttonDecrease,
              goingToZero && styles.buttonGoingToZero,
            ])
          }
          onClick={!disabled ? onDecrease : undefined}
          disabled={disabled || readOnly || loading || value <= min}
        >
          <i className={combineClassNames([styles.buttonIcon, styles.buttonIconDecrease])} />
        </button>
      )}
      {!valueZeroView && renderValue()}
      <button
        type="button"
        className={
          combineClassNames([
            styles.button,
            valueZeroView && styles.buttonValueZeroView,
            styles.buttonIncrease,
          ])
        }
        onClick={!disabled ? onIncrease : undefined}
        disabled={disabled || readOnly || loading || value >= max}
      >
        <i className={combineClassNames([styles.buttonIcon, styles.buttonIconIncrease])} />
      </button>
    </div>
  )
}

export default InputQuantityView
